import React from "react";
import { Alert, Card, Col, Row, Table, Badge, Image } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaCar, FaFilePdf } from "react-icons/fa";
import ModuleDisplayEmail from "../../../../UI/modules/fieldsDisplay/ModuleDisplayEmail";
import ModuleDisplayFieldsController from "../../../../UI/modules/fieldsDisplay/ModuleDisplayFieldsController";
import ModuleDisplayPhone from "../../../../UI/modules/fieldsDisplay/ModuleDisplayPhone";
import memberDummyImage from "../../../../../images/memberDummyImage.jpg";
import memberStatusEmailVerificationRequired from "../../../../../images/memberStatusEmailVerificationRequired.png";
import memberStatusSignupRequest from "../../../../../images/memberStatusSignupRequest.png";
import memberStatusRejected from "../../../../../images/memberStatusRejected.png";
import memberStatusRegistrationPaymentPending from "../../../../../images/memberStatusRegistrationPaymentPending.png";
import memberStatusMember from "../../../../../images/memberStatusMember.jpg";
import accountDeleted from "../../../../../images/accountDelete.png";
import ModuleDisplayBoolean from "../../../../UI/modules/fieldsDisplay/ModuleDisplayBoolean";
import StatsListing from "../../../../UI/shared/infoListing/StatsListing";
import { getFullName } from "../../../../../helpers/CommonHelper";
import ModuleDisplayDateTime from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDateTime";
import ModuleDisplayDate from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDate";
import MemberStatusBadge from "../MemberStatusBadge";
import StatsListingNew from "../../../../UI/shared/infoListing/StatsListingNew";
import { AiOutlineMail } from "react-icons/ai";
import { LiaWhatsapp } from "react-icons/lia";
import { FaMobileAlt } from "react-icons/fa";
import { FaCircleCheck, FaInstagram, FaLinkedinIn, FaTwitter, FaXTwitter, FaYoutube } from "react-icons/fa6";
import { FaTimesCircle } from "react-icons/fa";
import { FaCarAlt } from "react-icons/fa";
import { FaFileAlt } from "react-icons/fa";
import { MdGroups } from "react-icons/md";
import { GiChatBubble } from "react-icons/gi";
import { PiMoney } from "react-icons/pi";
import { FaFacebook } from "react-icons/fa";
import { BiSolidPhoneCall } from "react-icons/bi";
import ReactFancyBox from "react-fancybox";
import { MdInsertEmoticon } from "react-icons/md";
const Details = ({
  item,
  moduleConfig,
  confirmAndDelete,
  confirmAndBlock,
  confirmAndUnblock,
  customButtonsForItems,
}) => {
  var serverUploadsUrl = process.env.REACT_APP_BACKEND_URL + "public/";
  const fields = moduleConfig.fields;
  const getItems = () => {
    let items = [];
    if (item.oldMemberNumber) {
      items = [...items, { text: "Old Member Number", value: item.oldMemberNumber, type: "text" }];
    }
    if (item.email) {
      items = [...items, { text: "Email", value: item.email, type: "email" }];
    }
    if (item.mobile) {
      items = [...items, { text: "Mobile", value: item.mobile, type: "phone" }];
    }
    if (item.nationality) {
      items = [
        ...items,
        { text: "Nationality", value: item.nationality, type: "text" },
      ];
    }
    if (item.dob) {
      items = [
        ...items,
        { text: "Date of Birth", value: item.dob, type: "text" },
      ];
    }

    if (item.referredBy) {
      items = [
        ...items,
        { text: "Referred By", value: item.referredBy, type: "text" },
      ];
    }
    if (item.referredName) {
      items = [
        ...items,
        { text: "Referred Name", value: item.referredName, type: "text" },
      ];
    }
    if (item.status === "Member" && item.joiningDate) {
      items = [
        ...items,
        { text: "Member Since", value: item.joiningDate, type: "text" },
      ];
    }

    if (item.createdAt) {
      items = [
        ...items,
        { text: "Profile Created On", value: item.createdAt, type: "text" },
      ];
    }

    if (
      item.otherClub &&
      item.otherClub.enrolled === "1" &&
      item.otherClub.otherClub
    ) {
      items = [
        ...items,
        {
          text: "Other Club Membership",
          value: item.otherClub.otherClub,
          type: "text",
        },
      ];
    }

    if (item.about) {
      items = [...items, { text: "About", value: item.about, type: "text" }];
    }

    return items;
  };
  const getCounts = () => {
    let items = [
      {
        title: "Cars",
        value: item.stats.cars,
        url: `/member-cars/${item._id}`,
      },
      {
        title: "Registration(s)",
        value: item.stats.registrationCount,
        url: `/members/${item._id}`,
        click: false,
      },
      {
        title: "Circle(s)",
        value: item.stats.circlesCount,
        url: `/circles/`,
      },
      // {
      //   title: " Unread Messages",
      //   value: item.stats.unreadMessages,
      //   url: `/chat/member/${item._id}`,
      // },
      // {
      //   title: "Pending Payments",
      //   value: item.stats.pendingPaymentCount,
      //   url: `/payments/`,
      // },
    ];
    if (item.stats.unreadMessages > 0) {
      items = [
        ...items,
        { text: "Referred Name", value: item.referredName, type: "text" },
      ];
    }
    return items;
  };
  const getSocialMedia = () => {
    let items = [];
    if (item.socialAccounts.facebook) {
      items = [
        ...items,
        {
          text: "Facebook",
          value: item.socialAccounts.facebook,
          type: "link",
        },
      ];
    }
    if (item.socialAccounts.instagram) {
      items = [
        ...items,
        {
          text: "Instagram",
          value: item.socialAccounts.instagram,
          type: "link",
        },
      ];
    }
    if (item.socialAccounts.linkedin) {
      items = [
        ...items,
        {
          text: "Linked In",
          value: item.socialAccounts.linkedin,
          type: "link",
        },
      ];
    }
    if (item.socialAccounts.twitter) {
      items = [
        ...items,
        {
          text: "Twitter",
          value: item.socialAccounts.twitter,
          type: "link",
        },
      ];
    }

    if (item.socialAccounts.youtube) {
      items = [
        ...items,
        {
          text: "You Tube",
          value: item.socialAccounts.youtube,
          type: "link",
        },
      ];
    }

    return items;
  };
  const getAddressItems = () => {
    let items = [];
    if (item.address.city) {
      items = [
        ...items,
        { text: "City", value: item.address.city, type: "text" },
      ];
    }
    if (item.address.state) {
      items = [
        ...items,
        { text: "State", value: item.address.state, type: "text" },
      ];
    }
    if (item.address.country) {
      items = [
        ...items,
        { text: "Country", value: item.address.country, type: "text" },
      ];
    }
    if (item.address.address) {
      items = [
        ...items,
        {
          text: "Address",
          value: item.address.address,
          type: "text",
        },
      ];
    }

    return items;
  };
  const getJobItems = () => {
    let items = [];
    if (item.job.occupation) {
      items = [
        ...items,
        {
          text: "Occupation",
          value: item.job.occupation,
          type: "text",
        },
      ];
    }
    if (item.job.company) {
      items = [
        ...items,
        { text: "Company Name", value: item.job.company, type: "text" },
      ];
    }

    if (item.job.address) {
      items = [
        ...items,
        {
          text: "Comapny address",
          value: item.job.address,
          type: "text",
        },
      ];
    }

    return items;
  };
  const getPartnerItems = () => {
    let items = [];
    if (item.partner.fullName) {
      items = [
        ...items,
        {
          text: "Full Name",
          value: item.partner.fullName,
          type: "text",
        },
      ];
    }
    if (item.partner.email) {
      items = [
        ...items,
        { text: "email", value: item.partner.email, type: "email" },
      ];
    }
    if (item.partner.mobile) {
      items = [
        ...items,
        {
          text: "Mobile",
          value: item.partner.mobile,
          type: "phone",
        },
      ];
    }
    if (item.partner.clubCommunication) {
      items = [
        ...items,
        {
          text: "Club Communication",
          value: item.partner.clubCommunication,
          type: "boolean",
        },
      ];
    }

    return items;
  };
  const getConsentItems = () => {
    let items = [];
    if (item.consent && item.consent.agreeToShareDetails) {
      items = [
        ...items,
        {
          text: "Agree to share details",
          value: item.consent.agreeToShareDetails,
          type: "boolean",
        },
      ];
    }
    if (item.consent && item.consent.agreeToTakePictures) {
      items = [
        ...items,
        {
          text: "Agree to take pictures",
          value: item.consent.agreeToTakePictures,
          type: "boolean",
        },
      ];
    }

    if (item.consent && item.consent.agreeToSharePicturesOnSocial) {
      items = [
        ...items,
        {
          text: "Agree to share pictures on social media",
          value: item.consent.agreeToSharePicturesOnSocial,
          type: "boolean",
        },
      ];
    }

    return items;
  };
  const getPermissions = (permission) => {
    let items = [];
    if (permission.canManageAlbums === 1 || permission.canManageAlbums === "1") {
      items = [
        ...items,
        {
          text: "Manage Album",
          value: permission.canManageAlbums,
          type: "boolean",
        },
      ];
    }
    if (
      permission.canManageComments === 1 ||
      permission.canManageComments === "1"
    ) {
      items = [
        ...items,
        {
          text: "Manage Comments",
          value: permission.canManageComments,
          type: "boolean",
        },
      ];
    }
    if (
      permission.canManagePhotos === 1 ||
      permission.canManagePhotos === "1"
    ) {
      items = [
        ...items,
        {
          text: "Manage Photos",
          value: permission.canManagePhotos,
          type: "boolean",
        },
      ];
    }
    if (
      permission.canSendNotifications === 1 ||
      permission.canSendNotifications === "1"
    ) {
      items = [
        ...items,
        {
          text: "Send Notifications",
          value: permission.canSendNotifications,
          type: "boolean",
        },
      ];
    }
    if (
      permission.canViewMemberDetails === 1 ||
      permission.canViewMemberDetails === "1"
    ) {
      items = [
        ...items,
        {
          text: "View Member Details",
          value: permission.canViewMemberDetails,
          type: "boolean",
        },
      ];
    }
    if (permission.hasCMSAccess === 1 || permission.hasCMSAccess === "1") {
      items = [
        ...items,
        {
          text: "CMS Access",
          value: permission.hasCMSAccess,
          type: "boolean",
        },
      ];
    }
    return items;
  };
  return (
    <>
      <Card className={`item mb-2 memberItem`}>
        {item.accountDeletionRequested === "1" ||
          item.accountDeletionRequested === 1 ||
          item.accountDeletionRequested === true ? (
          <>
            <div
              className={` ${item.accountDeletionRequested === "1" ||
                item.accountDeletionRequested === 1 ||
                item.accountDeletionRequested === true
                ? "accountDeleted"
                : ""
                }`}
            ></div>
          </>
        ) : null}
        <Card.Header
          className={`ps-1 pe-xl-0 pe-2 py-0  ${item.accountDeletionRequested === "1" ||
            item.accountDeletionRequested === 1 ||
            item.accountDeletionRequested === true
            ? "accountDeletedBg"
            : ""
            }`}
        >
          <Card.Title className="m-0 p-0 ">
            <div className="d-flex ImageSectionSpacing align-items-center">
              <div className="position-relative ms-1 me-2">
                {/* {item.isChairman === "1" ||
                  item.isChairman === 1 ||
                  item.isChairman === true ? (
                  <div className="chairmanStatus">
                    <i
                      class="fa fa-star"
                      aria-hidden="true"
                      title={`${getFullName(item)
                        } is Chairman`}
                    ></i>
                  </div>
                ) : null} */}
                {item.archivedByAdmin === "0" && item.accountDeletionRequested === "1" ||
                  item.accountDeletionRequested === 1 ||
                  item.accountDeletionRequested === true ? (
                  <div className="accountDeleteIcon">
                    <i
                      class="fa fa-trash"
                      aria-hidden="true"
                      title={`${getFullName(
                        item
                      )} requested for account deletion`}
                    ></i>
                  </div>
                ) : null}

                {item.accountDeletionRequested === "1" ||
                  item.accountDeletionRequested === 1 ||
                  item.accountDeletionRequested === true ? null : (
                  <>
                    {item.isLoggedIn === "1" ||
                      item.isLoggedIn === 1 ||
                      item.isLoggedIn === true ? (
                      <div className="activeStatus"></div>
                    ) : (
                      <div className="notActiveStatus"></div>
                    )}
                  </>
                )}
                <>
                  {item.image ? (
                    <Image
                      src={
                        process.env.REACT_APP_BACKEND_URL +
                        "public/" +
                        item.image
                      }
                      width="52px"
                      height="52px"
                      className="border rounded-circle"
                    />
                  ) : (
                    <Image
                      src={memberDummyImage}
                      width="45px"
                      className="border rounded-circle"
                    />
                  )}
                </>

                {item.blockedByAdmin === "1" && (
                  <i className="fas fa-ban position-absolute  banned2"> </i>
                )}
              </div>

              <div className="d-flex flex-column ms-1">
                <span className="m-0 text-bold memberName ">
                  {getFullName(item)}


                  {item.role === "Board Member" ? (
                    <span className="boardMemberText">{item.role}</span>
                  ) : item.role === "Club President" ? (
                    <span className="greenBackgroundText">{item.role}</span>
                  ) : item.role === "Club Vice President" ? (
                    <span className="greenBackgroundText">{item.role}</span>
                  ) : item.role === "Member" ? null : (
                    <span className="normalText">({item.role})</span>
                  )}

                  {/* {item.hasCMSAccess === "1" && (
                    <span className="hasCMSAccessText">Has CMS Access</span>
                  )}

                  {item.allowedToViewMemberDetails === "1" && (
                    <span className="hasMemberDetailsAccessText"> Has Member Details Access</span>
                  )} */}
                </span>

                <span className="mt-1">
                  <MemberStatusBadge member={item} />
                </span>
              </div>
            </div>
          </Card.Title>

          <div className="card-tools">
            <div className=" text-right  mt-0 me-xl-2">
              {(item.archivedByAdmin === "1") && <><Badge bg="secondary" className="">Archived Date: <ModuleDisplayDate value={item.archiveDate} /></Badge>{" "}</>}
              {item.accountDeletionRequested === "1" ||
                item.accountDeletionRequested === 1 ||
                item.accountDeletionRequested === true ? (
                <Badge bg="dark" className="ms-1 me-1 resubmission">
                  Account Deletion Requested
                </Badge>
              ) : null}
              {(item.blockedByAdmin === "1") && <><Badge bg="secondary">Blocked Date: <ModuleDisplayDate value={item.blockDate} /></Badge>{" "}</>}
              {item.status === "Member" && item.expiryStatus !== "membershipIsExpired" && item.joiningDate && item.blockedByAdmin !== "1" && item.archivedByAdmin !== "1" && <><Badge bg="success">Member Since: <ModuleDisplayDate value={item.joiningDate} /></Badge>{" "}</>}
              {item.status !== "Member" && item.createdAt && item.blockedByAdmin !== "1" && item.archivedByAdmin !== "1" && <><Badge bg="warning">Profile Created On: {item.createdAt}</Badge>{" "}</>}
              {(item.expiryStatus === "membershipIsExpired" && item.blockedByAdmin !== "1" && item.expiredYear) && <><Badge bg="danger">Membership Expired Year : {item.expiredYear}</Badge>{" "}</>}
              {item.expiryStatus === "membershipIsInTolerancePeriod" && (
                <>
                  <Badge bg="warning">Tolerance Period</Badge>{" "}
                </>
              )}

              {item.expiryStatus === "membershipIsExpiringSoon" && (
                <>
                  <Badge bg="secondary">Expiring Soon</Badge>{" "}
                </>
              )}

              {item.migratedMember === "1" && (
                <>
                  <Badge bg="info" className="me-1">
                    Migrated Member
                  </Badge>{" "}
                </>
              )}

              {item.createdByAdmin === "1" && (
                <>
                  <Badge bg="primary" className="me-1">
                    Admin Created Profile
                  </Badge>{" "}
                </>
              )}
              {item.createdByAdmin === "0" && item.migratedMember === "0" && (
                <>
                  <Badge bg="purple" className="me-1">
                    Mobile App Signup
                  </Badge>{" "}
                </>
              )}

              {/* {item.status === "Member" && item.joiningDate && (
                <>
                  <Badge bg="success">Member Since: {item.joiningDate}</Badge>{" "}
                </>
              )}

              {item.createdAt && (
                <>
                  <Badge bg="warning">
                    Profile Created On: {item.createdAt}
                  </Badge>{" "}
                </>
              )} */}
            </div>

            <div className=" text-right  mt-0 me-xl-2">
              <span className="badge badge-light me-1 text-dark">
                Agreed With Terms :{" "}
                <span class="text-secondary">
                  <ModuleDisplayBoolean value={item.agreedWithTerms} />{" "}
                </span>
              </span>
              <span className="badge badge-light me-1 text-dark">
                Email Verified :{" "}
                <span class="text-secondary">
                  <ModuleDisplayBoolean value={item.emailVerified} />{" "}
                </span>
              </span>
            </div>
          </div>
        </Card.Header>
        <Card.Body className="px-0 pb-0 pt-xl-1 pt-0">
          {item.archivedByAdmin === "1" && item.archiveReason && (
            <Alert variant="secondary mt-1 mb-0 p-0 font-small mx-1 px-1">
              {" "}
              <p className="mb-0 text-bold font-small">
                Archived Reason :
                <span className="mb-0 text-normal ps-2">{item.archiveReason}</span>
              </p>
            </Alert>
          )}
          {item.accountDeletionRequested === "1" ||
            item.accountDeletionRequested === 1 ||
            item.accountDeletionRequested === true ? (
            <>
              {item.accountDeletionReason && (
                <Alert variant="dark mt-1 mb-0 p-0  font-small mx-1 px-1" >
                  {" "}
                  <p className="mb-0 text-bold font-small">
                    Account Deletion Reason :
                    <span className="mb-0 text-normal ps-2">
                      {item.accountDeletionReason}
                    </span>
                  </p>
                </Alert>
              )}
            </>
          ) : null}

          {item.clubAdminReactivated === "1" && item.clubAdminReactivationMessage ? (
            <>
              <Alert variant="dark mt-1 mb-0 p-0  font-small">
                {" "}
                <p className="mb-0 text-bold font-small">
                  Club Admin Message :
                  <span className="mb-0 text-normal ps-2">
                    {item.clubAdminReactivationMessage}
                  </span>
                </p>
              </Alert>
            </>
          ) : null}
          {item.rejectionReason &&
            (item.status === "SignupRequest" ||
              item.status === "SignupRequestRejected") && (
              <Alert variant="danger mx-1 mt-1 mb-0 p-0  font-small px-1">
                {" "}
                <p className="mb-0 text-bold font-small">
                  {(item.resubmission === "1" ? "Previous " : "") +
                    "Rejection Reason"}{" "}
                  :
                  <span className="mb-0 text-normal ps-2">
                    {item.rejectionReason}
                  </span>
                </p>
              </Alert>
            )}
          {item.blockedByAdmin === "1" && item.blockReason && (
            <Alert variant="danger mx-1 mt-1 mb-0 p-0  font-small">
              {" "}
              <p className="mb-0 text-bold font-small">
                Block Reason :
                <span className="mb-0 text-normal ps-2">
                  {item.blockReason}
                </span>
              </p>
            </Alert>
          )}
          {item.stats && item.stats.cars <= 0 && (
            <Alert variant="warning mx-1 mt-1 mb-0 p-0  font-small">
              {" "}
              <p className="mb-0 text-bold font-small">
                <span className="mb-0 text-normal ps-2">
                  This member doesn't have an active car.{" "}
                  {item.lastCarDeletedOn &&
                    item.lastCarDeletedOn.deletionDate && (
                      <>
                        Last car deleted on{" "}
                        <span className="text-bold">
                          <ModuleDisplayDate
                            value={item.lastCarDeletedOn.deletionDate}
                          />
                        </span>
                      </>
                    )}
                </span>
              </p>
            </Alert>
          )}
          {item.carConflicts && item.carConflicts.length == 1 && (
            <div className="warningDark mx-1 mt-1 mb-0 p-0  font-small">
              {" "}
              <p className="mb-0 text-bold font-small">
                <span className="mb-0 text-normal ps-2">
                  This member has a conflict with his/her car "
                  {item.carConflicts[0].model}"
                  <>
                    {item.carConflicts[0] &&
                      item.carConflicts[0].conflictReason && (
                        <span className="text-bold ps-2 mb-0">
                          Conflict Reason:
                          <span className="mb-0 text-normal ps-2">
                            {item.carConflicts[0].conflictReason}
                          </span>
                        </span>
                      )}
                  </>
                </span>
              </p>
            </div>
          )}
          {item.carConflicts && item.carConflicts.length > 1 && (
            <div className="warningDark mx-1 mt-1 mb-0 p-0  font-small">
              {" "}
              <p className="mb-0 text-bold font-small">
                <span className="mb-0 text-normal ps-2">
                  This member has a conflict with his/her car.
                </span>
              </p>
            </div>
          )}
          <Row className="w-100 mx-auto px-2 ">
            <>
              {(item.stats.cars > 0 ||
                item.stats.registrationCount > 0 ||
                item.stats.circlesCount > 0 ||
                item.stats.unreadMessages > 0 ||
                item.stats.pendingPaymentCount > 0) && (
                  <Col xl={12} lg={12} md={12} sm={12} xs={12} className="mt-2 me-2 p-0">
                    <div className="d-flex align-items-center justify-content-start flex-wrap">
                      {item.stats.cars > 0 && (
                        <Link to={`/member-cars/${item._id}`} className="activityFeeCardMargin warning cursor-pointer">
                          <div className="carTopHolder mb-0 border-0 pb-0">
                            <div className="carLeftHolder activity"> <FaCarAlt size={18} className="me-1" /> Car(s)</div>
                            <div className="carRightHolder">
                              {item.stats.cars}
                            </div>
                          </div>
                          {/* <div className="carDownHolder warning">{item.stats.cars}</div> */}
                        </Link>
                      )}
                      {item.stats.registrationCount > 0 && (
                        <Link to={`/members/${item._id}`} className="activityFeeCardMargin primary">
                          <div className="carTopHolder mb-0 border-0 pb-0">
                            <div className="carLeftHolder activity"> <FaFileAlt size={18} className="me-1" /> Registration(s)</div>
                            <div className="carRightHolder">
                              {item.stats.registrationCount}
                            </div>
                          </div>
                          {/* <div className="carDownHolder primary">{item.stats.registrationCount}</div> */}
                        </Link>
                      )}
                      {item.stats.circlesCount > 0 && (
                        <Link to={`/circles/`} className="activityFeeCardMargin pink">
                          <div className="carTopHolder mb-0 border-0 pb-0">
                            <div className="carLeftHolder activity">        <MdGroups size={22} className="me-1" /> Circle(s)</div>
                            <div className="carRightHolder">
                              {item.stats.circlesCount}
                            </div>
                          </div>
                          {/* <div className="carDownHolder pink">{item.stats.circlesCount}</div> */}
                        </Link>
                      )}
                      {item.stats.unreadMessages > 0 && (
                        <Link to={`/chat/member/${item._id}`} className="activityFeeCardMargin info">
                          <div className="carTopHolder mb-0 border-0 pb-0">
                            <div className="carLeftHolder activity"><GiChatBubble size={22} className="me-1" /> Unread Messages</div>
                            <div className="carRightHolder">
                              {item.stats.unreadMessages}
                            </div>
                          </div>
                          {/* <div className="carDownHolder info">{item.stats.unreadMessages}</div> */}
                        </Link>
                      )}
                      {item.stats.pendingPaymentCount > 0 && (
                        <Link to={`/payments/`} className="activityFeeCardMargin danger">
                          <div className="carTopHolder mb-0 border-0 pb-0">
                            <div className="carLeftHolder activity"> <PiMoney size={22} className="me-1" /> Payment Pending</div>
                            <div className="carRightHolder">
                              {item.stats.pendingPaymentCount}
                            </div>
                          </div>
                          {/* <div className="carDownHolder danger">{item.stats.pendingPaymentCount}</div> */}
                        </Link>
                      )}
                    </div>
                  </Col>
                )}</>
          </Row>
          <Row className="w-100 mx-auto">
            <Col xl={3} lg={6} md={12} sm={12} xs={12} className="pr-0 px-1 position-relative  mt-2 pt-0">
              <>
                <Card>
                  <Card.Body className=" pt-4 p-3">
                    <div className="carDetailsHead">Personal Details</div>
                    {item.email &&
                      <div className="displayRow ">
                        <div className="leftText">Email :</div>
                        <div className="rightText">
                          <p className="mb-0 linkDisplay"><ModuleDisplayEmail value={item.email} /></p>
                        </div>
                      </div>}
                    {item.mobile &&
                      <div className="displayRow ">
                        <div className="leftText">Mobile :</div>
                        <div className="rightText">
                          <p className="mb-0 linkDisplay"><ModuleDisplayPhone value={item.mobile} /></p>
                        </div>
                      </div>}
                    {item.emiratesID &&
                      <div className="displayRow ">
                        <div className="leftText">Emirates ID :</div>
                        <div className="rightText">
                          <p className="mb-0"><ModuleDisplayPhone value={item.emiratesId} /></p>
                        </div>
                      </div>}
                    {item.nationality &&
                      <div className="displayRow ">
                        <div className="leftText">Nationality :</div>
                        <div className="rightText">
                          <p className="mb-0">{item.nationality}</p>
                        </div>
                      </div>}
                    {item.dob &&
                      <div className="displayRow ">
                        <div className="leftText">Date of Birth :</div>
                        <div className="rightText">
                          <p className="mb-0">{item.dob}</p>
                        </div>
                      </div>}
                    {item.referredBy &&
                      <div className="displayRow ">
                        <div className="leftText">Referred By :</div>
                        <div className="rightText">
                          <p className="mb-0">{item.referredBy}</p>
                        </div>
                      </div>}
                    {item.referredName &&
                      <div className="displayRow ">
                        <div className="leftText">Referred Name :</div>
                        <div className="rightText">
                          <p className="mb-0">{item.referredName}</p>
                        </div>
                      </div>}
                    {item.createdAt &&
                      <div className="displayRow ">
                        <div className="leftText">Profile Created On :</div>
                        <div className="rightText">
                          <p className="mb-0">{item.createdAt}</p>
                        </div>
                      </div>}
                    {item.joiningDate &&
                      <div className="displayRow ">
                        <div className="leftText">Member Since :</div>
                        <div className="rightText">
                          <p className="mb-0">{item.joiningDate}</p>
                        </div>
                      </div>}
                    {item.job && item.job.occupation &&
                      <div className="displayRow ">
                        <div className="leftText">Occupation :</div>
                        <div className="rightText">
                          <p className="mb-0">{item.job.occupation}</p>
                        </div>
                      </div>}
                    {item.oldMemberNumber &&
                      <div className="displayRow ">
                        <div className="leftText">Old Member Number :</div>
                        <div className="rightText">
                          <p className="mb-0">{item.oldMemberNumber}</p>
                        </div>
                      </div>}
                    {item.socialAccounts &&
                      <div className="socialAccounts mt-2">
                        {item.socialAccounts.facebook &&
                          <a href={item.socialAccounts.facebook} target="_blank">
                            <Card className="mt-0 me-2 mb-1 socialCard">
                              <Card.Body className="px-2 py-2 socialCard">
                                <FaFacebook size={25} className="" />
                              </Card.Body>
                            </Card>
                          </a>}
                        {item.socialAccounts.instagram &&
                          <a href={item.socialAccounts.instagram} target="_blank">

                            <Card className="mt-0 me-2 mb-1 socialCard">
                              <Card.Body className="px-2 py-2 socialCard">
                                <FaInstagram size={25} className="" />
                              </Card.Body>
                            </Card>
                          </a>}
                        {item.socialAccounts.linkedin &&
                          <a href={item.socialAccounts.linkedin} target="_blank">
                            <Card className="mt-0 me-2 mb-1 socialCard">
                              <Card.Body className="px-2 py-2 socialCard">
                                <FaLinkedinIn size={25} className="" />
                              </Card.Body>
                            </Card>
                          </a>}
                        {item.socialAccounts.youtube &&
                          <a href={item.socialAccounts.youtube} target="_blank">
                            <Card className="mt-0 me-2 mb-1 socialCard">
                              <Card.Body className="px-2 py-2 socialCard">
                                <FaYoutube size={25} className="" />
                              </Card.Body>
                            </Card>
                          </a>}
                        {item.socialAccounts.twitter &&
                          <a href={item.socialAccounts.twitter} target="_blank">
                            <Card className="mt-0 me-2 mb-1 socialCard">
                              <Card.Body className="px-2 py-2 socialCard">
                                <FaXTwitter size={25} className="" />
                              </Card.Body>
                            </Card>
                          </a>}
                      </div>}
                  </Card.Body>
                </Card>


              </>
            </Col>

            {(item.address || item.partner) &&
              <Col xl={3} lg={6} md={12} sm={12} xs={12} className="px-1 position-relative  mt-2">
                {item.address &&
                  <Card>
                    <Card.Body className="p-0">
                      <div className="position-relative pt-4">
                        <div className="carDetailsHead ">Address</div>
                        {item.address.city &&
                          <div className="displayRow ">
                            <div className="leftText">City :</div>
                            <div className="rightText">
                              <p className="mb-0">{item.address.city}</p>
                            </div>
                          </div>}
                        {item.address.state &&
                          <div className="displayRow ">
                            <div className="leftText">State :</div>
                            <div className="rightText">
                              <p className="mb-0">{item.address.state}</p>
                            </div>
                          </div>}
                        {item.address.country &&
                          <div className="displayRow ">
                            <div className="leftText">Country :</div>
                            <div className="rightText">
                              <p className="mb-0">{item.address.country}</p>
                            </div>
                          </div>}
                        {item.address.address &&
                          <div className="displayRow ">
                            <div className="leftText">Address :</div>
                            <div className="rightText">
                              <p className="mb-0">{item.address.address}</p>
                            </div>
                          </div>}
                      </div>
                    </Card.Body>
                  </Card>
                }
                {item.partner &&
                  <Card>
                    <Card.Body className="p-0">
                      <div className="position-relative pt-4 mt-0">
                        <div className="carDetailsHead ">Partner</div>
                        {item.partner.fullName &&
                          <div className="displayRow ">
                            <div className="leftText">Full Name :</div>
                            <div className="rightText">
                              <p className="mb-0">{item.partner.fullName}</p>
                            </div>
                          </div>}
                        {item.partner.email &&
                          <div className="displayRow ">
                            <div className="leftText">Email :</div>
                            <div className="rightText ">
                              <p className="mb-0 linkDisplay"><ModuleDisplayEmail value={item.partner.email} /></p>
                            </div>
                          </div>}
                        {item.partner.mobile &&
                          <div className="displayRow ">
                            <div className="leftText">Mobile :</div>
                            <div className="rightText">
                              <p className="mb-0 linkDisplay"><ModuleDisplayPhone value={item.partner.mobile} /></p>
                            </div>
                          </div>}
                        {item.partner.clubCommunication &&
                          <div className="displayRow ">
                            <div className="leftText">Club Communication :</div>
                            <div className="rightText">
                              <p className="mb-0"><ModuleDisplayBoolean value={item.partner.clubCommunication} /></p>
                            </div>
                          </div>}
                      </div></Card.Body>
                  </Card>}
              </Col>}
            {item.cars && item.cars.length > 0 &&
              <Col xl={3} lg={6} md={12} sm={12} xs={12} className="px-1 position-relative  mt-2">
                {item.cars.map((car, index) => {
                  return (
                    <>
                      <Card>
                        <Card.Body className=" pt-4 p-3">
                          <div className="carDetailsHead">Car(s)</div>

                          <div className="carTopHolder mt-0">
                            <div className="carLeftHolder mt-2">
                              <div className="d-flex align-items-center">
                                <FaCar size={25} className="me-2" />
                                {car.model &&
                                  <p className="model mb-0">{car.model}</p>}
                              </div>

                              <p className="color mb-0 small fontItalic">{car.chassisNumber}</p>
                            </div>
                            <div className="carRightHolder">
                              {car.year &&
                                <p className="year mb-0 text-dark">{car.year}</p>}
                            </div>
                          </div>
                          {item.cars.length <= 1 &&
                            <>
                              {car.color &&
                                <div className="displayRow ">
                                  <div className="leftText">Color :</div>
                                  <div className="rightText">
                                    <p className="mb-0">{car.color}</p>
                                  </div>
                                </div>}
                              {car.emirate &&
                                <div className="displayRow ">
                                  <div className="leftText">Emirate :</div>
                                  <div className="rightText">
                                    <p className="mb-0">{car.emirate}</p>
                                  </div>
                                </div>}
                              {car.dateOfPurchase &&
                                <div className="displayRow">
                                  <div className="leftText">Date of Purchase :</div>
                                  <div className="rightText">
                                    <p className="mb-0">
                                      <ModuleDisplayDate value={car.dateOfPurchase} />
                                    </p>
                                  </div>
                                </div>}
                              {car.purchaseFrom &&
                                <div className="displayRow">
                                  <div className="leftText">Purchased From :</div>
                                  <div className="rightText">
                                    <p className="mb-0">{car.purchaseFrom}</p>
                                  </div>
                                </div>}
                              {car.plateNumber &&
                                <div className="displayRow">
                                  <div className="leftText">Plate Number :</div>
                                  <div className="numberPlate">
                                    <p className="mb-0">{car.plateNumber}</p>
                                  </div>
                                </div>}
                            </>}
                        </Card.Body>
                      </Card>



                    </>
                  )
                })}


              </Col>}
            {(item.modeOfComm || item.inAppComm) &&
              <Col xl={3} lg={4} md={5} sm={6} xs={12} className="mt-2 p-0 px-1">
                {item.modeOfComm &&
                  <Card>
                    <Card.Body className="pt-4 px-3 pb-1">

                      <div className="carDetailsHead">Mode of Communication</div>

                      <div className="carTopHolder pb-2  pb-0">
                        <div className="carLeftHolder">
                          <AiOutlineMail className="mx-2" /> Email
                        </div>
                        <div className="carRightHolder">
                          {item.modeOfComm.email ? <FaCircleCheck className="text-success" /> : <FaTimesCircle className="text-danger" />}
                        </div>
                      </div>



                      <div className="carTopHolder pb-2  pb-0">
                        <div className="carLeftHolder">
                          <LiaWhatsapp className="mx-2" /> Whatsapp
                        </div>
                        <div className="carRightHolder">
                          {item.modeOfComm.whatsApp ? <FaCircleCheck className="text-success" /> : <FaTimesCircle className="text-danger" />}
                        </div>
                      </div>



                      <div className="carTopHolder  border-0  pb-0">
                        <div className="carLeftHolder">
                          <FaMobileAlt className="mx-2" /> Mobile App
                        </div>
                        <div className="carRightHolder">
                          {item.modeOfComm.mobileApp ? <FaCircleCheck className="text-success" /> : <FaTimesCircle className="text-danger" />}
                        </div>
                      </div>



                    </Card.Body>
                  </Card>
                }
                {item.inAppComm &&
                  <Card>
                    <Card.Body className="pt-4 px-3 pb-1">

                      <div className="carDetailsHead">In App Communication</div>

                      <div className="carTopHolder  pb-2">
                        <div className="carLeftHolder">
                          <AiOutlineMail className="mx-2" /> Email
                        </div>
                        <div className="carRightHolder">
                          {item.inAppComm.email ? <FaCircleCheck className="text-success" /> : <FaTimesCircle className="text-danger" />}
                        </div>
                      </div>


                      <div className="carTopHolder pb-2">
                        <div className="carLeftHolder">
                          <BiSolidPhoneCall className="mx-2" /> Call
                        </div>
                        <div className="carRightHolder">
                          {item.inAppComm.whatsApp ? <FaCircleCheck className="text-success" /> : <FaTimesCircle className="text-danger" />}
                        </div>
                      </div>


                      <div className="carTopHolder mb-0 border-0 pb-2">
                        <div className="carLeftHolder">
                          <GiChatBubble className="mx-2" /> Chat
                        </div>
                        <div className="carRightHolder">
                          {item.inAppComm.mobileApp ? <FaCircleCheck className="text-success" /> : <FaTimesCircle className="text-danger" />}
                        </div>
                      </div>


                    </Card.Body>
                  </Card>
                }

              </Col>}
            {item.hobbies?.length > 0 &&
              <Col xl={3} lg={4} md={2} sm={6} xs={6} className=" mt-2 p-0  px-1">
                <Card>
                  <Card.Body className="pt-4 px-3 pb-1">
                    <div className="carDetailsHead ">Hobbies</div>
                    <ul className="hobbiesList">

                      {item.hobbies.map((car, index) => {
                        return (
                          <>
                            <li className={``}>{car.hobby}</li>
                          </>
                        )
                      })}
                    </ul>
                  </Card.Body>
                </Card>


              </Col>}

            {(item.consent) &&
              <Col xl={3} lg={6} md={5} sm={6} xs={12} className=" mt-2 p-0 px-1">

                <Card>
                  <Card.Body className="pt-4 px-3 pb-1">
                    <div className="carDetailsHead">Consent</div>


                    <div className="displayRow ">
                      <div className="leftText"> Agree to share pictures on social media :</div>
                      <div className="rightText">
                        <p className="mb-0"> {item.consent.agreeToSharePicturesOnSocial === "1" ? <FaCircleCheck className="text-success" /> : <FaTimesCircle className="text-danger" />}</p>
                      </div>
                    </div>

                    <div className="displayRow ">
                      <div className="leftText">Agree to take pictures :</div>
                      <div className="rightText">
                        <p className="mb-0"> {item.consent.agreeToTakePictures === "1" ? <FaCircleCheck className="text-success" /> : <FaTimesCircle className="text-danger" />}</p>
                      </div>
                    </div>

                    <div className="displayRow border-0 ">
                      <div className="leftText">Agree to share details :</div>
                      <div className="rightText">
                        <p className="mb-0"> {item.consent.agreeToShareDetails === "1" ? <FaCircleCheck className="text-success" /> : <FaTimesCircle className="text-danger" />}</p>
                      </div>
                    </div>



                  </Card.Body>

                </Card>


              </Col>}
            {item.permissions && item.permissions.some(permission =>
              permission.canManageAlbums === "1" ||
              permission.canManageComments === "1" ||
              permission.canManagePhotos === "1" ||
              permission.canSendNotifications === "1" ||
              permission.canViewMemberDetails === "1" ||
              permission.hasCMSAccess === "1" ||
              permission.canManagePolls === "1"
            ) && (
                <Col xl={3} lg={6} md={5} sm={6} xs={12} className=" mt-2 p-0 px-1">
                  <Card>
                    <Card.Body className="pt-4 pb-1 px-1">


                      <div className="carDetailsHead">Permissions</div>

                      {item.permissions.map((permission, index) => {
                        const permissionLabels = [];

                        if (permission.canManageAlbums === "1") permissionLabels.push("Manage Albums");
                        if (permission.canManageComments === "1") permissionLabels.push("Manage Comments");
                        if (permission.canManagePhotos === "1") permissionLabels.push("Manage Photos");
                        if (permission.canSendNotifications === "1") permissionLabels.push("Send Notifications");
                        if (permission.canViewMemberDetails === "1") permissionLabels.push("View Member Details");
                        if (permission.hasCMSAccess === "1") permissionLabels.push("CMS Access");
                        if (permission.canManagePolls === "1") permissionLabels.push("Manage Polls");

                        if (permissionLabels.length > 0) {
                          return (
                            <>

                              {permissionLabels.map((label, i) => (
                                <div className="displayRow" key={i}>
                                  <div className="leftText">{label} :</div>
                                  <div className="rightText">
                                    <p className="mb-0">
                                      <FaCircleCheck className="text-success" />
                                    </p>
                                  </div>
                                </div>
                              ))}

                            </>
                          );
                        }
                        return null;
                      })}
                    </Card.Body>
                  </Card>
                </Col>
              )}
            {item.emiratesIdFront && item.emiratesIdBack && (
              <Col xl={3} lg={4} md={5} sm={6} xs={12} className=" mt-2 p-0 px-1">
                <Card>
                  <Card.Body className="px-0 pb-0">
                    <div className="carDetailsHead">Emirates ID</div>

                    {item.emiratesIdFront.toLowerCase().endsWith(".pdf") ? (
                      <div className="carTopHolder pb-0  pb-2 pt-3 px-3">
                        <div className="carLeftHolder">
                          <div className="align-items-center d-flex py-0 mb-0 px-0 justify-content-center">
                            <a
                              href={`${serverUploadsUrl}${item.emiratesIdFront}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-info fontItalic"
                            >
                              View Emirates ID (Front) PDF
                            </a>
                          </div>
                        </div>
                        <div className="carRightHolder">
                          <FaFilePdf className="text-danger" />
                        </div>
                      </div>
                    ) : (
                      <div className="align-items-center d-flex py-2 mb-0 px-0 justify-content-center">
                        <div className="emiratesId">
                          <ReactFancyBox
                            thumbnail={`${serverUploadsUrl}${item.emiratesIdFront}`}
                            image={`${serverUploadsUrl}${item.emiratesIdFront}`}
                          />
                        </div>
                      </div>
                    )}

                    {item.emiratesIdBack.toLowerCase().endsWith(".pdf") ? (
                      <div className="carTopHolder pb-0  border-0 py-2 px-3">
                        <div className="carLeftHolder">
                          <div className="align-items-center d-flex py-0 mb-0 px-0 justify-content-center">
                            <a
                              href={`${serverUploadsUrl}${item.emiratesIdBack}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-info fontItalic"
                            >
                              View Emirates ID (Back) PDF
                            </a>
                          </div>
                        </div>
                        <div className="carRightHolder">
                          <FaFilePdf className="text-danger" />
                        </div>
                      </div>
                    ) : (
                      <div className="align-items-center d-flex py-2 mb-0 px-0 justify-content-center">
                        <div className="emiratesId">
                          <ReactFancyBox
                            thumbnail={`${serverUploadsUrl}${item.emiratesIdBack}`}
                            image={`${serverUploadsUrl}${item.emiratesIdBack}`}
                          />
                        </div>
                      </div>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            )}

          </Row>




        </Card.Body>
      </Card>
    </>
  );
};

export default Details;
